export const ABgameInfos = {
  develop: {
    pubgm: [
      '1000005',
      '1000006',
      '1001282',
      '1000009',
      '1000259',
      '1001108',
      '1001281',
    ],
    'mobile-legends': [
      '1001283',
      '1001314',
      '1000249',
      '1001315',
      '1001308',
      '1000252',
      '1001301',
      '1001302',
      '1001303',
      '1001304',
      '1001305',
    ],
  },
  production: {
    pubgm: [
      '1000259',
      '1000312',
      '1000308',
      '1000309',
      '1000313',
      '1000314',
      '1000315',
      '1000316',
      '1000317',
      '1000318',
    ],
    'mobile-legends': [
      '1000319',
      '1000320',
      '1000321',
      '1000322',
      '1000323',
      '1000307',
      '1000324',
      '1000325',
      '1000326',
      '1000327',
      '1000328',
    ],
  },
}
export const abTestFilterate = (rootState, rootGetters, skuList) => {
  const { ABtestCode, gameName } = rootState
  const restrict = rootGetters?.isHotCpTaxIncrease
  const env = process.env.VUE_APP_ENV_TYPE
  const ev = env && env === 'production' ? 'production' : 'develop'
  const currentGames = ABgameInfos[ev][gameName]

  // 命中实验
  if (restrict) {
    if (skuList && skuList?.length) {
      if (ABtestCode && ABtestCode === '10011') {
        return skuList.filter((item) => currentGames.includes(item.skuId))
      }
      return skuList.filter((item) => !currentGames.includes(item.skuId))
    }
    return []
  }
  return skuList
}
